import { useState } from 'react';
import { TUNABLE } from '@/lib/pitch';

// Guitar keeps its original storage keys
const customKey = (id) => (id === 'guitar' ? 'tuner.customTunings' : `tuner.customTunings.${id}`);
const selectedKey = (id) => (id === 'guitar' ? 'tuner.guitarTuning' : `tuner.tuning.${id}`);
const loadCustom = (id) => { try { return JSON.parse(localStorage.getItem(customKey(id)) || '[]'); } catch { return []; } };

export function addCustomTuning(instrumentId, { name, notes }) {
  const existing = loadCustom(instrumentId).find((t) => t.name === name && t.notes.join() === notes.join());
  const id = existing?.id || `custom-${Date.now()}`;
  if (!existing) {
    const list = [...loadCustom(instrumentId), { id, name, notes, custom: true }];
    localStorage.setItem(customKey(instrumentId), JSON.stringify(list));
  }
  localStorage.setItem(selectedKey(instrumentId), id);
  return !existing;
}

export function useTunings(instrumentId) {
  const { presets, counts } = TUNABLE[instrumentId];
  const [custom, setCustom] = useState(() => loadCustom(instrumentId));
  const [selectedId, setSelectedId] = useState(() => localStorage.getItem(selectedKey(instrumentId)) || 'standard');

  const persist = (list) => { setCustom(list); localStorage.setItem(customKey(instrumentId), JSON.stringify(list)); };
  const select = (id) => { setSelectedId(id); localStorage.setItem(selectedKey(instrumentId), id); };

  const save = (tuning) => {
    const id = tuning.id || `custom-${Date.now()}`;
    const entry = { ...tuning, id, custom: true };
    persist(custom.some((t) => t.id === id) ? custom.map((t) => (t.id === id ? entry : t)) : [...custom, entry]);
    select(id);
  };

  const remove = (id) => {
    persist(custom.filter((t) => t.id !== id));
    if (selectedId === id) select('standard');
  };

  const tuning = [...presets, ...custom].find((t) => t.id === selectedId) || presets[0];
  return { instrumentId, presets, counts, custom, tuning, select, save, remove };
}
